import React from 'react';
import PageHeader from './global-components/page-header';
import Cat from './section-components/cat-fashion';

const CatFashion = () => {
    return <div>
        <PageHeader headertitle="Fashion"  />
        <Cat />
    </div>
}

export default CatFashion

